module.exports = __webpack_public_path__ + "img/check-availability-red-gif-01.e805123c.gif";